import { w as A } from "./lit-element-6iugfgmM.js";
import { e as b, i as j, t as C } from "./directive-B5s9Ooqi.js";
import { p as D, v as p, r as v, h as x, m as E } from "./directive-helpers-B5UsscjS.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const w = (r, f, c) => {
  const h = /* @__PURE__ */ new Map();
  for (let e = f; e <= c; e++) h.set(r[e], e);
  return h;
}, M = b(class extends j {
  constructor(r) {
    if (super(r), r.type !== C.CHILD) throw Error("repeat() can only be used in text expressions");
  }
  dt(r, f, c) {
    let h;
    c === void 0 ? c = f : f !== void 0 && (h = f);
    const e = [], i = [];
    let l = 0;
    for (const a of r) e[l] = h ? h(a, l) : l, i[l] = c(a, l), l++;
    return { values: i, keys: e };
  }
  render(r, f, c) {
    return this.dt(r, f, c).values;
  }
  update(r, [f, c, h]) {
    const e = D(r), { values: i, keys: l } = this.dt(f, c, h);
    if (!Array.isArray(e)) return this.ut = l, i;
    const a = this.ut ?? (this.ut = []), u = [];
    let m, g, s = 0, o = e.length - 1, t = 0, n = i.length - 1;
    for (; s <= o && t <= n; ) if (e[s] === null) s++;
    else if (e[o] === null) o--;
    else if (a[s] === l[t]) u[t] = p(e[s], i[t]), s++, t++;
    else if (a[o] === l[n]) u[n] = p(e[o], i[n]), o--, n--;
    else if (a[s] === l[n]) u[n] = p(e[s], i[n]), v(r, u[n + 1], e[s]), s++, n--;
    else if (a[o] === l[t]) u[t] = p(e[o], i[t]), v(r, e[s], e[o]), o--, t++;
    else if (m === void 0 && (m = w(l, t, n), g = w(a, s, o)), m.has(a[s])) if (m.has(a[o])) {
      const d = g.get(l[t]), y = d !== void 0 ? e[d] : null;
      if (y === null) {
        const k = v(r, e[s]);
        p(k, i[t]), u[t] = k;
      } else u[t] = p(y, i[t]), v(r, e[s], y), e[d] = null;
      t++;
    } else x(e[o]), o--;
    else x(e[s]), s++;
    for (; t <= n; ) {
      const d = v(r, u[n + 1]);
      p(d, i[t]), u[t++] = d;
    }
    for (; s <= o; ) {
      const d = e[s++];
      d !== null && x(d);
    }
    return this.ut = l, E(r, u), A;
  }
});
export {
  M as c
};
//# sourceMappingURL=repeat-0w4vgNOf.js.map
